import { Box, useTheme } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "providers/i18n"
import { Head } from "components/Head"
import { MotionDiv } from "components/motions"
import { useKidsAndFamily } from "extensions/em-kids-and-family/hooks/useKidsAndFamily"
import { OccupantImageCard } from "extensions/em-core/components/ImageCard"
import { useVenue } from "providers/venue"
import { getFeatureDetail } from "utils/feature"

const SECTION_DISPLAY_LIMIT = 4

export const EMKidsAndFamilyMobilePage = () => {
  const { isMultiOrdinalVenue } = useVenue()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { occupants, sections } = useKidsAndFamily()

  const theme = useTheme()
  const styleOverrides =
    theme.components[`EmKidAndFamilyPage`]?.styleOverrides || {}
  const { gridContainer, gridItem } = styleOverrides || {}

  return (
    <>
      <Head title={t("Kid's and family")} />
      <MotionDiv
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.15 }}
      >
        {(sections.length > 0 || occupants.length > 0) && (
          <Box sx={gridContainer}>
            {sections
              .slice(0, SECTION_DISPLAY_LIMIT)
              .concat(occupants)
              .map((data) => {
                const {
                  id,
                  level,
                  logo,
                  name,
                  featuredImage,
                  categoryIconPath,
                  isFeatured,
                } = getFeatureDetail(data) || {}

                const dataName = t(name)
                const isSection = data?.feature_type === "section"

                const levelText = isMultiOrdinalVenue ? t(level) : ""

                return (
                  <OccupantImageCard
                    key={id}
                    id={id}
                    sx={gridItem}
                    coverImage={featuredImage}
                    logoSrc={logo}
                    iconPath={categoryIconPath}
                    primaryText={dataName}
                    adornmentText={levelText}
                    isFeatured={isFeatured}
                    isSection={isSection}
                    onClick={() => navigate(`/maps/place/${id}`)}
                  />
                )
              })}
          </Box>
        )}
      </MotionDiv>
    </>
  )
}
